/**
 * #installation.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { App } from "./app.js";
/** App render expectation. */
export var RenderVersion;
(function (RenderVersion) {
    RenderVersion[RenderVersion["RENDER_VERSION_UNSPECIFIED"] = 0] = "RENDER_VERSION_UNSPECIFIED";
    /** NO_DEVVIT_JSON - `devvit.yaml` Blocks app. */
    RenderVersion[RenderVersion["NO_DEVVIT_JSON"] = 256] = "NO_DEVVIT_JSON";
    /** WEBBIT_BLOCKS - Classic or hybrid Webbit app. */
    RenderVersion[RenderVersion["WEBBIT_BLOCKS"] = 512] = "WEBBIT_BLOCKS";
    RenderVersion[RenderVersion["WEBBIT_PURE_NO_ENTRYPOINT"] = 1024] = "WEBBIT_PURE_NO_ENTRYPOINT";
    /** WEBBIT_PURE_NO_INLINE - Entry exists but isn't explicitly inline. */
    RenderVersion[RenderVersion["WEBBIT_PURE_NO_INLINE"] = 1040] = "WEBBIT_PURE_NO_INLINE";
    /** WEBBIT_PURE_INLINE - Entry exists and is explicitly inline. */
    RenderVersion[RenderVersion["WEBBIT_PURE_INLINE"] = 1056] = "WEBBIT_PURE_INLINE";
    RenderVersion[RenderVersion["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RenderVersion || (RenderVersion = {}));
export function renderVersionFromJSON(object) {
    switch (object) {
        case 0:
        case "RENDER_VERSION_UNSPECIFIED":
            return RenderVersion.RENDER_VERSION_UNSPECIFIED;
        case 256:
        case "NO_DEVVIT_JSON":
            return RenderVersion.NO_DEVVIT_JSON;
        case 512:
        case "WEBBIT_BLOCKS":
            return RenderVersion.WEBBIT_BLOCKS;
        case 1024:
        case "WEBBIT_PURE_NO_ENTRYPOINT":
            return RenderVersion.WEBBIT_PURE_NO_ENTRYPOINT;
        case 1040:
        case "WEBBIT_PURE_NO_INLINE":
            return RenderVersion.WEBBIT_PURE_NO_INLINE;
        case 1056:
        case "WEBBIT_PURE_INLINE":
            return RenderVersion.WEBBIT_PURE_INLINE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RenderVersion.UNRECOGNIZED;
    }
}
export function renderVersionToJSON(object) {
    switch (object) {
        case RenderVersion.RENDER_VERSION_UNSPECIFIED:
            return 0;
        case RenderVersion.NO_DEVVIT_JSON:
            return 256;
        case RenderVersion.WEBBIT_BLOCKS:
            return 512;
        case RenderVersion.WEBBIT_PURE_NO_ENTRYPOINT:
            return 1024;
        case RenderVersion.WEBBIT_PURE_NO_INLINE:
            return 1040;
        case RenderVersion.WEBBIT_PURE_INLINE:
            return 1056;
        case RenderVersion.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseInstallation() {
    return {
        installationId: "",
        publicApiVersion: "",
        hostname: "",
        app: undefined,
        bundleUrl: "",
        location: "",
        renderVersion: undefined,
    };
}
export const Installation = {
    $type: "reddit.devvit.common.v1.Installation",
    encode(message, writer = _m0.Writer.create()) {
        if (message.installationId !== "") {
            writer.uint32(10).string(message.installationId);
        }
        if (message.publicApiVersion !== "") {
            writer.uint32(18).string(message.publicApiVersion);
        }
        if (message.hostname !== "") {
            writer.uint32(26).string(message.hostname);
        }
        if (message.app !== undefined) {
            App.encode(message.app, writer.uint32(34).fork()).ldelim();
        }
        if (message.bundleUrl !== "") {
            writer.uint32(42).string(message.bundleUrl);
        }
        if (message.location !== "") {
            writer.uint32(50).string(message.location);
        }
        if (message.renderVersion !== undefined) {
            writer.uint32(56).int32(message.renderVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInstallation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.installationId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.publicApiVersion = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.hostname = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.app = App.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.bundleUrl = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.location = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.renderVersion = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            installationId: isSet(object.installationId) ? globalThis.String(object.installationId) : "",
            publicApiVersion: isSet(object.publicApiVersion) ? globalThis.String(object.publicApiVersion) : "",
            hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
            app: isSet(object.app) ? App.fromJSON(object.app) : undefined,
            bundleUrl: isSet(object.bundleUrl) ? globalThis.String(object.bundleUrl) : "",
            location: isSet(object.location) ? globalThis.String(object.location) : "",
            renderVersion: isSet(object.renderVersion) ? globalThis.Number(object.renderVersion) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.installationId !== "") {
            obj.installationId = message.installationId;
        }
        if (message.publicApiVersion !== "") {
            obj.publicApiVersion = message.publicApiVersion;
        }
        if (message.hostname !== "") {
            obj.hostname = message.hostname;
        }
        if (message.app !== undefined) {
            obj.app = App.toJSON(message.app);
        }
        if (message.bundleUrl !== "") {
            obj.bundleUrl = message.bundleUrl;
        }
        if (message.location !== "") {
            obj.location = message.location;
        }
        if (message.renderVersion !== undefined) {
            obj.renderVersion = Math.round(message.renderVersion);
        }
        return obj;
    },
    create(base) {
        return Installation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallation();
        message.installationId = object.installationId ?? "";
        message.publicApiVersion = object.publicApiVersion ?? "";
        message.hostname = object.hostname ?? "";
        message.app = (object.app !== undefined && object.app !== null) ? App.fromPartial(object.app) : undefined;
        message.bundleUrl = object.bundleUrl ?? "";
        message.location = object.location ?? "";
        message.renderVersion = object.renderVersion ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(Installation.$type, Installation);
function isSet(value) {
    return value !== null && value !== undefined;
}
